export const LOGIN_FETCH_DATA_SUCCESS = 'LOGIN_FETCH_DATA_SUCCESS';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOADING_LOGIN_FAILED = 'LOADING_LOGIN_FAILED';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const MONTHLY_TOTAL = 'MONTHLY_TOTAL';
export const OPEN_DAYS = 'OPEN_DAYS';
export const INITIAL_ORDER = 'INITIAL_ORDER';
export const INVITES = 'INVITES';
export const USER_ON_TRACK = 'USER_ON_TRACK';
export const SHOW_INVITE_FRIENDS = 'SHOW_INVITE_FRIENDS';

export const OFFER_PAYOUT = 'OFFER_PAYOUT';
export const RETRY = 'RETRY';
export const NEXT_PAYOUT = 'NEXT_PAYOUT';
export const SUCCESSFUL_MONTHS = 'SUCCESSFUL_MONTHS';
export const PERIOD_BEGIN = 'PERIOD_BEGIN';
export const PERIOD = 'PERIOD';

export const DAYS_FETCH_DATA_SUCCESS = 'DAYS_FETCH_DATA_SUCCESS';
export const DAYS_LOADING = 'DAYS_LOADING';
export const LOADING_DAYS_FAILED = 'LOADING_DAYS_FAILED';
export const EXTEND_OR_PAYOUT = 'EXTEND_OR_PAYOUT';
export const BET_MODE = 'BET_MODE';
export const POST_ID = 'POST_ID';
export const LINK = 'LINK';
export const AD = 'AD';

export const WORKOUT_FETCH_DATA_SUCCESS = 'WORKOUT_FETCH_DATA_SUCCESS';
export const WORKOUT_LOADING = 'WORKOUT_LOADING';
export const LOADING_WORKOUT_FAILED = 'LOADING_WORKOUT_FAILED';
export const WORKOUT_ALREADY_MISSED = 'WORKOUT_ALREADY_MISSED';

export const SUBMIT_FETCH_DATA_SUCCESS = 'SUBMIT_FETCH_DATA_SUCCESS';
export const SUBMIT_LOADING = 'SUBMIT_LOADING';
export const LOADING_SUBMIT_FAILED = 'LOADING_SUBMIT_FAILED';
export const SUBMIT_ALREADY_MISSED = 'SUBMIT_ALREADY_MISSED';

export const REORDER_FETCH_DATA_SUCCESS = 'REORDER_FETCH_DATA_SUCCESS';
export const REORDER_CORRUPTED = 'REORDER_CORRUPTED';
export const REORDER_LOADING = 'REORDER_LOADING';
export const LOADING_REORDER_FAILED = 'LOADING_REORDER_FAILED';

export const LEVEL_FETCH_DATA_SUCCESS = 'LEVEL_FETCH_DATA_SUCCESS';
export const LEVEL_LOADING = 'LEVEL_LOADING';
export const LOADING_LEVEL_FAILED = 'LOADING_LEVEL_FAILED';

export const FEEDBACK_FETCH_DATA_SUCCESS = 'FEEDBACK_FETCH_DATA_SUCCESS';
export const FEEDBACK_LOADING = 'FEEDBACK_LOADING';
export const LOADING_FEEDBACK_FAILED = 'LOADING_FEEDBACK_FAILED';

export const DECLINE_PAYOUT_SUCCESS = 'DECLINE_PAYOUT_SUCCESS';
export const DECLINE_PAYOUT_LOADING = 'DECLINE_PAYOUT_LOADING';
export const LOADING_DECLINE_PAYOUT_FAILED = 'LOADING_DECLINE_PAYOUT_FAILED';

export const REQUEST_PAYOUT_SUCCESS = 'REQUEST_PAYOUT_SUCCESS';
export const REQUEST_PAYOUT_LOADING = 'REQUEST_PAYOUT_LOADING';
export const LOADING_REQUEST_PAYOUT_FAILED = 'LOADING_REQUEST_PAYOUT_FAILED';

export const RETRY_SUCCESS = 'RETRY_SUCCESS';
export const RETRY_LOADING = 'RETRY_LOADING';
export const LOADING_RETRY_FAILED = 'LOADING_RETRY_FAILED';

export const PAUSE_SUCCESS = 'PAUSE_SUCCESS';
export const PAUSE_LOADING = 'PAUSE_LOADING';
export const LOADING_PAUSE_FAILED = 'LOADING_PAUSE_FAILED';


// WEBPACK FOOTER //
// ./src/actions/types.js